import { render, staticRenderFns } from "./DayProviderDishesTable.vue?vue&type=template&id=342fc36b&"
import script from "./DayProviderDishesTable.vue?vue&type=script&lang=js&"
export * from "./DayProviderDishesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DayProviderDishesTable.vue"
export default component.exports